export enum PageStep{
    STEP_PERSONNEL_DETAIL=1,
    STEP_CONTACT_DETAIL=2,
    STEP_OCCUPATION_INVESTMENT_DETAIL=3,
    STEP_BANK_DETAIL=4,
    STEP_OTHER_DETAIL=5,
    STEP_ATTACHMENT_SUPPORT_DETAIL=6,
    STEP_ACKNOWLEDGMENT_DETAIL=7,
    STEP_SUMMARY_VIEW=8,


}